import type {Cell, CellObject} from '@PosterWhiteboard/items/layouts/cells/cell';
import type {CellType} from "@PosterWhiteboard/items/layouts/cells/cell.types";
import type {CellData, DateData, TimeData} from '@PosterWhiteboard/items/table-item/table-data.types';

export type LayoutDataMap = Partial<Record<CellType, Cell[]>>;
export type ColumnsDataMap = LayoutDataMap;
export type LayoutDataMapObject = Partial<Record<CellType, CellObject[]>>;

export type ScheduleDataType = DateData | TimeData | CellData;

export enum LayoutData {
  TABLE_LAYOUT = 'layout-1',
  BAND_LAYOUT_LEFT_ALIGN = 'layout-2',
  BAND_LAYOUT_RIGHT_ALIGN = 'layout-6',
  BAND_LAYOUT_CENTER_ALIGN = 'layout-7',
  SPORTS_LAYOUT = 'layout-3',
  SLANTED_SPORTS_LAYOUT = 'layout-4',
  STRAIGHT_SPORTS_LAYOUT = 'layout-8',
  OFFSET_SPORTS_LAYOUT = 'layout-9',
}

export interface ScheduleData {
  rows: number;
  columns: number;
  tableData: ScheduleDataType[][];
  columnsData: CellType[];
  layoutStyle: LayoutData;
  highlightedRows: number[];
  unusedData: ScheduleDataType[][];
}
